module.exports = __webpack_public_path__ + "img/PGR_A05_back_diagonal_en.658d8034.png";